module.exports = __webpack_public_path__ + "static/media/S-task03_adjMatrix.3efe1333.png";